<template>
  <div id="app">
    <div data-collapse="medium" data-animation="default" data-duration="400" class="navigation w-nav">
      <div class="navigation-wrap">
        <div class="div-block-5">
          <img src="images/epicare.png" alt="Logo EpiCare" />
        </div>
        <div class="menu"></div>
      </div>
    </div>
    <Certificate />
  </div>
</template>

<script>
import Certificate from './components/Certificate.vue'

export default {
  name: 'App',
  components: {
    Certificate
  }
}
</script>

